import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useCommerceApi, useAccessToken} from '@salesforce/commerce-sdk-react'
import {USEQUERY_OPTIONS} from '../constants'
import usePageDesigner from './use-page-designer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

const usePDP = (parameters) => {
    const queryParams = USEQUERY_OPTIONS
    const api = useCommerceApi()
    const {site} = useMultiSite()
    const {getTokenWhenReady} = useAccessToken()
    const {
        app: {commerceAPI}
    } = getConfig()
    let productCacheTime = 60 * 1000
    const {storefront} = commerceAPI || {}
    const {caching} = storefront || {}
    try {
        const cachingConfig = JSON.parse(caching || '{}')
        productCacheTime = cachingConfig.productCacheTime || productCacheTime
    } catch (e) {
        console.log(e.message)
    }
    /** ---- 1. Fetch product ---- **/
    const productQuery = useQuery({
        queryKey: [
            'use-pdp-product',
            parameters?.product?.id,
            parameters?.customerGroupIds || '-',
            parameters?.product?.c_selectedCurrency || 'USD'
        ],
        queryFn: async () => {
            try {
                const token = await getTokenWhenReady()
                return api.shopperProducts.getProduct({
                    parameters: parameters?.product || {},
                    headers: {Authorization: `Bearer ${token}`}
                })
            } catch (error) {
                logger.error('Error fetching PDP product', {
                    namespace: 'usePDP.productQuery',
                    additionalProperties: {error}
                })
                throw error
            }
        },
        ...queryParams,
        staleTime: productCacheTime,
        enabled: true
    })

    const primaryCategoryId = productQuery.data?.c_primaryCategory

    /** ---- 2. Fetch page designer only after product ---- **/
    const enabledPdQuery = !!primaryCategoryId && !isServer
    parameters.pageDesigner = {
        ...parameters?.pageDesigner,
        categoryId: primaryCategoryId,
        siteId: site?.id
    }
    const {data: pdQuery} = usePageDesigner(
        {
            isPdp: true,
            pageDesigner: {...parameters?.pageDesigner}
        },
        {enabled: !!enabledPdQuery}
    )

    /** ---- Return combined result ---- **/
    return {
        data: {
            product: productQuery.data,
            pageDesigner: pdQuery
        },
        isLoading: productQuery.isLoading,
        isError: productQuery.isError,
        error: productQuery.error
    }
}

export default usePDP
